import { defineRule } from "vee-validate";

defineRule("required", (value, [name]) => {
  if ((!value && value != 0) || value.length <= 0) {
    if (name) {
      return `The ${name} field is required`;
    }
    return "This field is required";
  }
  return true;
});

defineRule("email", (value) => {
  if (
    value &&
    !/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$/.test(value)
  ) {
    return "Please enter valid email";
  }
  return true;
});

defineRule("phone", (value) => {
  if (value && !/^[0-9]{10}$/.test(value)) {
    return "The Phone Number field must be numeric and exactly contain 10 digits";
  }
  return true;
});

defineRule("minLength", (value, [limit]) => {
  if (value.length < limit) {
    return `This field must be at least ${limit} characters`;
  }
  return true;
});

defineRule("confirmed", (value, [target]) => {
  if (value === target) {
    return true;
  }
  return "Passwords must match";
});

defineRule("price", (value) => {
  if (value && !/^[0-9]\d*(\.\d{1,2}?)?$/.test(value)) {
    return "Please enter valid value";
  }

  return true;
});

defineRule("number", (value) => {
  if (value && !/^[0-9]\d*(\d{1,2}?)?$/.test(value)) {
    return "Please enter valid value";
  }
  return true;
});

defineRule("heightFeet", (value) => {
  // Accepts empty or digits 1-7
  if (value && !/^[1-7]$/.test(String(value))) {
    return "Please enter height (feet) between 1 and 7";
  }
  return true;
});

defineRule("heightInch", (value) => {
  // Accepts empty or 0-12
  if (value && !/^(?:0|[1-9]|1[0-2])$/.test(String(value))) {
    return "Please enter height (inches) between 0 and 12";
  }
  return true;
});

defineRule("vin", (value) => {
  // VIN in this app: alphanumeric and exactly 17 characters
  if (value && !/^[A-Za-z0-9]{17}$/.test(value)) {
    return "Please enter a 17-character VIN (letters and numbers only)";
  }
  return true;
});

defineRule("unitcode", (value) => {
  // Accept empty or exactly 4 alphanumeric characters
  if (value) {
    const str = String(value);
    if (str.length < 4) {
      return "Unit Code must be 4 characters";
    }
    if (!/^[A-Za-z0-9]{4}$/.test(str)) {
      return "Please enter a 4-character Unit Code (letters and numbers only)";
    }
  }
  return true;
});

// Ensure speed meets 65+ requirement when applicable
defineRule("minSpeed65", (value) => {
  if (value) {
    const num = Number(String(value).replace(/\D/g, ""));
    if (isNaN(num)) return "Please enter valid speed";
    if (num < 65) {
      return "Speed must be 65 mph or greater";
    }
  }
  return true;
});

defineRule("instagram", (value) => {
  if (
    value &&
    !/^(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_.~#?&//=]*)?$/.test(
      value
    )
  ) {
    return "Please enter valid instagram url";
  }
  return true;
});

defineRule("facebook", (value) => {
  if (
    value &&
    !/^(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_.~#?&//=]*)?$/.test(
      value
    )
  ) {
    return "Please enter valid facebook url";
  }
  return true;
});
